export default "__VITE_ASSET__51cb014f__"